import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { CategoryGamesProvider, useCasinoNewState, useCategoryGamesState } from '@atlas/core';
import { Loader } from '@atlas/ui';

import { useCasinoFilterState } from 'components/Casino/CasinoFilterContext';
import { CasinoCategory } from 'components/Casino/components/CasinoCategory';
import { GAME_SIZES, GROUPS } from 'components/Casino/constants';
import { casinoFilterTypeMap, deleteCasinoFilter } from 'components/Casino/useCasinoFilter';
import { scrollToTopHandler } from 'src/components/Footer/scrollToTopHandler';

const LobbyAnyCategoriesBlockContent = ({ categoryId, setActiveItem }) => {
  const { group } = useCasinoNewState();
  const { categoryGames, loading } = useCategoryGamesState();
  const { updateFilter } = useCasinoFilterState();

  const category = useMemo(() => {
    if (!categoryId) return null;
    return categoryGames.find(cat => String(cat.id) === String(categoryId));
  }, [categoryGames, categoryId]);

  const sliderSettings = useMemo(() => {
    if (group === GROUPS.LIVE) {
      return { rows: 1, size: GAME_SIZES.MEDIUM };
    }
    return { rows: 2, size: GAME_SIZES.MEDIUM };
  }, [group]);

  const showCategoryHandler = useCallback(
    id => () => {
      updateFilter({ providerNames: [] });
      deleteCasinoFilter(casinoFilterTypeMap.providerNames);
      setActiveItem(id.toString());
      scrollToTopHandler('auto');
    },
    [setActiveItem, updateFilter],
  );

  if (loading) {
    return (
      <div className="casino-lobby__item">
        <Loader />
      </div>
    );
  }

  if (!category) {
    return null;
  }

  return (
    <div className="casino-lobby__item">
      <CasinoCategory
        category={category}
        showCategoryHandler={showCategoryHandler}
        sliderSettings={sliderSettings}
      />
    </div>
  );
};

LobbyAnyCategoriesBlockContent.propTypes = {
  categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setActiveItem: PropTypes.func,
};

const LobbyAnyCategoriesBlock = ({ categoryId, setActiveItem }) => {
  const { group } = useCasinoNewState();

  return (
    <CategoryGamesProvider gamesCount={20} group={group}>
      <LobbyAnyCategoriesBlockContent categoryId={categoryId} setActiveItem={setActiveItem} />
    </CategoryGamesProvider>
  );
};

LobbyAnyCategoriesBlock.propTypes = {
  categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setActiveItem: PropTypes.func,
};

export default LobbyAnyCategoriesBlock;
